import initEducatorsSlider from "./init-educators-slider";
import initFaqSlider from "./init-faq-slider";
import initGraduatesSlider from "./init-graduates-slider";
import initMediaSlider from "./init-media-slider";
import initHowTOGetSlider from "./init-how-to-get-slider";
import initStatusSlider from "./init-status-slider";
import initCategoriesSlider from "./init-categories-slider";
import initDissmisalriskSlider from "./init-dissmisalrisk-slider";
import initEducationSlider from "./init-education-slider";
import initCommentsSlider from "./init-comments-slider";
import initPartnersSlider from "./init-partners-slider";

const sliders = () => {
    initCategoriesSlider();
    initGraduatesSlider();
    initEducatorsSlider();
    initMediaSlider();
    initFaqSlider();
    initHowTOGetSlider();
    initStatusSlider();
    initDissmisalriskSlider();
    initEducationSlider();
    initCommentsSlider();
    initPartnersSlider();
}

export default sliders;